import React from "react";
import { Link } from "react-router-dom";
import { classNames } from "../../helpers/classNames";

const Button = ({
  buttonEffect = "",
  buttonClasses,
  buttonType = "button",
  buttonIcon,
  buttonIconRight,
  buttonIconPosition = "left",
  buttonIconRightPosition = "right",
  buttonLabel,
  buttonLabelClasses,
  buttonFunction = () => {},
  buttonHasLink,
  buttonLink,
  buttonIconClass,
  isDisable = false,
  loading = false,
  target,
  variant = "primary",
  style,
  ...props
}) => {
  const renderButtonContent = () => (
    <>
      {buttonIconPosition === "left" && (loading || buttonIcon) && (
        <span
          {...(style?.color && { style: { color: style?.color } })}
          className={classNames("text-xl font-bold", buttonIconClass)}
        >
          <i
            className={classNames(
              "fa-fw",
              loading
                ? "fa-duotone fa-solid fa-spinner-third animate-spin"
                : buttonIcon
            )}
          ></i>
        </span>
      )}
      {buttonLabel && (
        <span
          {...(style?.color && { style: { color: style?.color } })}
          className={classNames(
            "font-medium text-sm uppercase whitespace-nowrap",
            buttonLabelClasses,
            variant === "secondary" ? "!text-deep-purple" : ""
          )}
        >
          {buttonLabel}
        </span>
      )}
      {(buttonIconPosition === "right" && (loading || buttonIcon)) ||
        (buttonIconRightPosition === "right" &&
          (loading || buttonIconRight) && (
            <span
              {...(style?.color && { style: { color: style?.color } })}
              className="text-xl font-bold"
            >
              <i className={classNames("fa-fw", buttonIconRight)}></i>
            </span>
          ))}
    </>
  );

  const baseClasses = classNames(
    "relative flex border border-transparent justify-center items-center gap-2 text-white font-semibold text-base h-12 px-6 rounded-full",
    variant === "primary"
      ? "bg-primary-gradient"
      : variant === "secondary"
      ? "bg-transparent !text-deep-purple !border-gray-200 hover:!bg-primary/10"
      : "",
    "hover:opacity-90 transition-all duration-300",
    isDisable ? "pointer-events-none opacity-75" : "",
    buttonClasses
  );

  return (
    <>
      {buttonHasLink ? (
        <Link
          to={buttonLink}
          {...(target && { target })}
          className={baseClasses}
          {...(style && { style })}
        >
          {renderButtonContent()}
        </Link>
      ) : (
        <button
          type={buttonType}
          className={baseClasses}
          onClick={buttonFunction}
          disabled={isDisable}
          {...(style && { style })}
        >
          {renderButtonContent()}
        </button>
      )}
    </>
  );
};

export default Button;
